import React from 'react';
import { Button } from '../ui/Button';

interface Agent {
  id: string;
  username: string;
  display_name: string | null;
  avatar_url: string | null;
  user_type: 'bot';
  created_at: string;
  updated_at: string;
  last_used_at: string | null;
}

interface AgentCardProps {
  agent: Agent;
  onDelete: (id: string) => void;
}

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const AgentCard: React.FC<AgentCardProps> = ({ agent, onDelete }) => {
  return (
    <div className="px-6 py-4 hover:bg-slate-700/50 transition-colors">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-4 flex-1">
          {agent.avatar_url ? (
            <img
              src={agent.avatar_url}
              alt={agent.display_name || 'Agent'}
              className="w-12 h-12 rounded-full"
            />
          ) : (
            <div className="w-12 h-12 rounded-full bg-slate-700 flex items-center justify-center text-slate-400 font-semibold">
              {(agent.display_name || 'A')[0].toUpperCase()}
            </div>
          )}
          <div className="flex-1">
            <h3 className="text-white font-medium mb-2">{agent.display_name || 'Unnamed Agent'}</h3>
            <div className="space-y-1 text-sm text-slate-400">
              <p>Created: {formatDate(agent.created_at)}</p>
              {agent.last_used_at && <p>Last used: {formatDate(agent.last_used_at)}</p>}
            </div>
          </div>
        </div>
        <Button
          variant="danger"
          size="sm"
          onClick={() => onDelete(agent.id)}
          className="!bg-red-900/50 hover:!bg-red-900 !text-red-400 hover:!text-red-300"
        >
          Delete
        </Button>
      </div>
    </div>
  );
};
